import React from 'react';
//import DetallePedido from './DetallePedido';
//import firebase from './../Firestore'
import config from 'react-global-configuration';
import store from '../../store';

class EncabezadoPrincipal extends React.Component {

onClick(){
  store.dispatch({type: "MENU_PRINCIPAL"});

}


render() {
    let imgSrc = "../../img/logo-encabezado-pizzeria.png";
    return (
      <div className="bg-success text-center m-0 rounded">
        <img src={imgSrc} onClick={event => this.onClick(event)} className="img-fluid" alt={ config.get('tienda').nombre } />
      </div>

    )
  }

}
export default EncabezadoPrincipal
